export enum OnlineDocumentType {
  ApplicationForm = '01',
  ConsentLetter = '02',
  IdentityCardFront = '03',
  StudentCardFrontAndBack = '04',
  GuarantorIC = '05',
  GuarantorIncomeDocuments = '06',
  IncomeDocumentPaysip = '07',
  Others = '08',
  IdentityCardBack = '09',
  IncomeDocumentIE_BankStatement = '10'
}